module.exports = __webpack_public_path__ + "static/media/checkbox_checked_tick.10cd6076.svg";